var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formInscripcion"},[_c('v-container',[_c('FormInscripcion')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }